<template>
  <div class="page_title">
    <span><img src="@/assets/home.png" alt="">首页</span><span v-for="item in  list" :key="item"><img
        src="@/assets/右箭头.png" alt="">{{item}}</span>
    <div @click="showDrawer" class="showMenu">
      <img src="@/assets/菜单.png" alt="">菜单
    </div>
    <a-drawer placement="right" :closable="false" width='164px' :visible="visible"
      :after-visible-change="afterVisibleChange" @close="onClose">
      <p @click="goUrl()" class="menu_item">欢迎辞</p>
      <p @click="goUrl()" class="menu_item">组织架构</p>
      <p @click="goUrl()" class="menu_item">会议信息</p>
      <p @click="goUrl()" class="menu_item">会议日程</p>
      <p @click="goUrl()" class="menu_item">日程查询</p>
      <p @click="goUrl()" class="menu_item">联系我们</p>
    </a-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: ['会议日程', '我的会议', '我的预约', '我的订单'],
      showMenu: false,
      visible: false,
    }
  },
  methods: {
    afterVisibleChange(val) {
      console.log('visible', val);
    },
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
  },
}
</script>

<style lang="less" scoped>
.page_title {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 52px;
  background-color: rgb(66, 70, 86);
  z-index: 999;
  padding: 0 15px;
  color: #fff;
  display: flex;
  align-items: center;
  position: relative;
  span {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
  img {
    width: 12px;
    margin: 0 2px;
  }
}
.showMenu {
  position: absolute;
  right: 15px;
  height: 100%;
  display: flex;
  align-items: center;
}
.menuList {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.7);
}
.menuData {
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  width: 164px;
  background-color: #fff;
}
.menu_item {
  font-size: 16px;
  color: #000000;
  text-align: center;
  line-height: 55px;
}
</style> 